(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-click-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.dlB2BClickTracking) return;
  window.dlB2BClickTracking = true;
  const names = new Set(['b2b_info_click', 'b2b_portal_click', 'b2b_webshop_click']);
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch { return; }
    let name = link.dataset.b2bEvent;
    let position = link.dataset.ctaLocation;
    if (!name && destination.hostname === 'b2b.directlicentie.nl') {
      if (destination.pathname === '/zakelijk-account') {
        name = 'b2b_portal_click';
        position = 'business_page_details';
      } else if (destination.pathname === '/account') {
        name = 'b2b_portal_click';
        position = 'business_page_login';
      }
    }
    if (!names.has(name)) return;
    const shopify = window.Shopify;
    if (typeof shopify?.analytics?.publish !== 'function') return;
    if (typeof shopify.customerPrivacy?.analyticsProcessingAllowed === 'function' &&
        !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    const payload = {
      cta_location: position || 'business_page',
      link_url: destination.origin + destination.pathname,
      link_text: link.textContent.trim(),
      page_location: window.location.origin + window.location.pathname,
      theme_id: String(shopify.theme?.id || ''),
      debug_mode: new URLSearchParams(window.location.search).has('preview_theme_id')
    };
    try {
      const result = shopify.analytics.publish(name, payload);
      if (typeof result?.catch === 'function') result.catch(() => {});
    } catch {}
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
